import { maxChars } from './maxChars';

export const max255chars = maxChars(255);
